import { render } from "./WinningPopup.vue?vue&type=template&id=ef7894dc&scoped=true"
import script from "./WinningPopup.vue?vue&type=script&lang=js"
export * from "./WinningPopup.vue?vue&type=script&lang=js"

import "./WinningPopup.vue?vue&type=style&index=0&id=ef7894dc&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef7894dc"]])

export default __exports__